import { createSelector } from "@reduxjs/toolkit";
import { initialState } from "./slice";
import { reduceArr } from "@utils/helpers";

const selectDomain = (state) => state.homepage || initialState;

export const makeSelectQuery = createSelector(
  selectDomain,
  (state) => state.query
);

export const makeSelectSelectedProductDetails = createSelector(
  selectDomain,
  (state) => state.selectedProductDetails
);

export const makeSelectProductDetails = createSelector(
  makeSelectSelectedProductDetails,
  (substate) => substate.productDetails
);

export const makeSelectSchemeDetails = createSelector(
  makeSelectSelectedProductDetails,
  (substate) => substate.schemeDetails
);

export const makeSelectOne = createSelector(
  makeSelectSelectedProductDetails,
  (substate) => substate.one
);

export const makeSelectVariantTest = createSelector(
  makeSelectSelectedProductDetails,
  (substate) => substate.variantTest
);

export const makeSelectAvailableVariantKeys = createSelector(
  makeSelectSelectedProductDetails,
  (substate) => substate.availableVariantsKeys
);

export const makeSelectIsAvailableVariant = createSelector(
  makeSelectSelectedProductDetails,
  (state) => state.is_available_to_buy
);

export const makeSelectOfficeOptions = createSelector(
  selectDomain,
  (state) => state.officeOptions
);

export const makeSelectOfficeOptionsNorm = createSelector(
  makeSelectOfficeOptions,
  (substate) => reduceArr(substate)
);

export const makeSelectOrderOpenSuccess = createSelector(
  selectDomain,
  (state) => state.openOrderSucc
);

export const makeSelectOrderConfirmedData = createSelector(
  selectDomain,
  (state) => state.orderConfirmedData
);

export const makeSelectDistrictOptions = createSelector(
  selectDomain,
  (state) => state.districtOptions
);

export const makeSelectDistrictOptionsNorm = createSelector(
  makeSelectDistrictOptions,
  (state) => reduceArr(state)
);

export const makeSelectVdcOptions = createSelector(
  selectDomain,
  (state) => state.vdcsOptions
);

export const makeSelectVdcOptionsNorm = createSelector(
  makeSelectVdcOptions,
  (state) => reduceArr(state)
);
